let colors = [
  { inputColor: "black-light-bg", cardColor: "black-bg" },
  {
    inputColor: "light-brown-bg",
    cardColor: "brown-bg",
  },
  {
    inputColor: "olive-light-bg",
    cardColor: "olive-dark-bg",
  },
  {
    inputColor: "violet-light-bg ",
    cardColor: "violet-bg",
  },
  {
    inputColor: "yellow-green-light",
    cardColor: "yellow-green",
  },
  {
    inputColor: "muddy-blue-light ",
    cardColor: "muddy-blue",
  },
  {
    inputColor: "green-light ",
    cardColor: "green-bg",
  },
  {
    inputColor: "greenish-blue-light",
    cardColor: "greenish-blue-bg ",
  },
];

export { colors };
